import config from "../../config";
import Navbar from "../../components/partials/Navbar";
import Footer from "../../components/partials/Footer";
import billing from "../../images/charts_billing.png";
import checkmarkWhite from "../../images/checkmark_circle_white.png";
import playstore from "../../images/playstore.png";
import partners from "../../images/partners.png";
import inventory from "../../images/manage_inventory.png";
import checkmarkOrange from "../../images/checkmark_circle_orange.png";
import salePurchase from "../../images/sale_purchase.png";
import verifiedCustomer from "../../images/verified_customer.png";
import gstFilling from "../../images/gst_filling.png";
import whyUsIcon1 from "../../images/why_us_icon_1.png";
import whyUsIcon2 from "../../images/why_us_icon_2.png";
import whyUsIcon3 from "../../images/why_us_icon_3.png";
import whyUsIcon4 from "../../images/why_us_icon_4.png";
import whyUsIcon5 from "../../images/why_us_icon_5.png";
import whyUsIcon6 from "../../images/why_us_icon_6.png";
import testimonial from "../../images/testimonial.png";
import doubleQuotes from "../../images/double_quotes.png";
import star from "../../images/star.png";
import "./style.css"

function Home() {
    return (
        <>
            <Navbar/>

            <section className="mt-3" id="gst-billing">
                <div className="container">
                    <div className="row pt-3 pb-5 align-items-center">
                        <div className="col-sm-5 px-sm-0">
                            <span className="notify px-3 py-1 rounded-pill">
                                <img src={checkmarkWhite} className="img-fluid me-2 mb-1" alt=""/>
                                100% SAFE & SECURE
                            </span>
                            <h1 className="my-4 title">GST Billing <span className="text-primary">Invoice</span> in
                                India Business....</h1>
                            <p className="text-muted">Lorem ipsum dolor sit amet consectetur. Mauris urna amet faucibus
                                sed amet vestibulum. Diam cursus risus praesent auctor.</p>
                            <div className="d-flex flex-column flex-sm-row mt-5 align-items-center">
                                <a href={config.links.playstore}
                                   className="btn btn-primary px-4 py-2 me-0 me-sm-4 mb-3 mb-sm-0">Download
                                    Mobile App</a>
                                <a href={config.links.playstore}><img src={playstore} className="img-fluid w-100"
                                                                      alt=""/></a>
                            </div>
                        </div>
                        <div className="col-sm-7 px-sm-0 mt-5">
                            <img src={billing} className="img-fluid" alt=""/>
                        </div>
                    </div>
                </div>
            </section>

            <section className="my-5" id="partners">
                <div className="container">
                    <div className="row">
                        <div className="col p-5 text-center">
                            <h2 className="mb-4">Over 32k+ software businesses growing with Account App</h2>
                            <img src={partners} className="w-90" alt=""/>
                        </div>
                    </div>
                </div>
            </section>

            <section className="mb-4" id="manage-inventory">
                <div className="container">
                    <div className="row py-4 align-items-center">
                        <div className="col-sm-6 px-sm-0">
                            <h1 className="my-3">Manage Inventory Seamlessly</h1>
                            <p className="text-muted">Our Inventory Management Software is designed to streamline your
                                processes and increase profits.</p>
                            <ul className="list-unstyled row row-cols-2 mt-4">
                                <div className="col">
                                    <li className="my-2">
                                        <img src={checkmarkOrange} className="img-fluid me-2" alt=""/>
                                        Min/Max Stock Levels
                                    </li>
                                    <li className="my-2">
                                        <img src={checkmarkOrange} className="img-fluid me-2" alt=""/>
                                        Inventory Valuation
                                    </li>
                                    <li className="my-2">
                                        <img src={checkmarkOrange} className="img-fluid me-2" alt=""/>
                                        Negative Stock Restriction
                                    </li>
                                </div>
                                <div className="col">
                                    <li className="my-2">
                                        <img src={checkmarkOrange} className="img-fluid me-2" alt=""/>
                                        Barcode Tracking
                                    </li>
                                    <li className="my-2">
                                        <img src={checkmarkOrange} className="img-fluid me-2" alt=""/>
                                        Auto Stock Adjustment
                                    </li>
                                    <li className="my-2">
                                        <img src={checkmarkOrange} className="img-fluid me-2" alt=""/>
                                        Multiple Stores
                                    </li>
                                </div>
                            </ul>
                            <div className="d-flex mt-4 align-items-center">
                                <a href="#" className="btn btn-primary px-4 py-2">Read More</a>
                            </div>
                        </div>
                        <div className="col-sm-6 px-sm-0">
                            <img src={inventory} className="img-fluid" alt=""/>
                        </div>
                    </div>
                </div>
            </section>

            <section className="mb-4" id="verified-customer">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-sm-6 px-sm-0">
                            <img src={verifiedCustomer} className="img-fluid" alt=""/>
                        </div>
                        <div className="col-sm-6 px-sm-0">
                            <span className="notify text-primary">Our Feature</span>
                            <h1 className="my-4">Create GST Bills for customers hare them</h1>
                            <p className="text-muted">Account billing software helps you set up a professional brand
                                identity with useful GST billing features. You can</p>
                            <div className="d-flex mt-5 align-items-center">
                                <a href="#" className="btn btn-primary px-4 py-2">Read More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="mb-4" id="sale-purchase">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-sm-6 px-sm-0">
                            <h1 className="my-3">Sales & Purchase</h1>
                            <p className="text-muted">Manage sales and purchase orders, create invoices, and E-way bills
                                from a single order management system.</p>
                            <ul className="list-unstyled row row-cols-2 mt-4">
                                <div className="col">
                                    <li className="my-2">
                                        <img src={checkmarkOrange} className="img-fluid me-2" alt=""/>
                                        Order Confirmation
                                    </li>
                                    <li className="my-2">
                                        <img src={checkmarkOrange} className="img-fluid me-2" alt=""/>
                                        Sales Order
                                    </li>
                                    <li className="my-2">
                                        <img src={checkmarkOrange} className="img-fluid me-2" alt=""/>
                                        Credit/Debit Note
                                    </li>
                                </div>
                                <div className="col">
                                    <li className="my-2">
                                        <img src={checkmarkOrange} className="img-fluid me-2" alt=""/>
                                        Inward/GRN Register
                                    </li>
                                    <li className="my-2">
                                        <img src={checkmarkOrange} className="img-fluid me-2" alt=""/>
                                        Purchase Order
                                    </li>
                                    <li className="my-2">
                                        <img src={checkmarkOrange} className="img-fluid me-2" alt=""/>
                                        Service Transactions
                                    </li>
                                </div>
                            </ul>
                            <div className="d-flex mt-4 align-items-center">
                                <a href="#" className="btn btn-primary px-4 py-2">Read More</a>
                            </div>
                        </div>
                        <div className="col-sm-6 px-sm-0">
                            <img src={salePurchase} className="img-fluid" alt=""/>
                        </div>
                    </div>
                </div>
            </section>

            <section className="mb-5" id="gst-filling">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-sm-6 px-sm-0">
                            <img src={gstFilling} className="img-fluid" alt=""/>
                        </div>
                        <div className="col-sm-6 px-sm-0">
                            <span className="notify text-primary">Our Feature</span>
                            <h1 className="my-4">GST filing made simpler and faster</h1>
                            <p className="text-muted">Filing GST is a challenge for business owners and is a long
                                process if done manually. Using Account App</p>
                            <div className="d-flex mt-5 align-items-center">
                                <a href="#" className="btn btn-primary px-4 py-2">Read More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="mb-7" id="why-us">
                <div className="container px-5">
                    <div className="row align-items-center">
                        <div className="col pb-4">
                            <h1 className="my-4 text-center">Why Our Customers Use <span className="highlight">Account App</span>
                            </h1>
                        </div>
                    </div>
                    <div className="row row-cols-sm-2 row-cols-md-3 g-5 mx-sm-0">
                        <div className="col">
                            <div className="card p-4" role="button">
                                <div className="card-body text-center">
                                    <img src={whyUsIcon1} className="img-fluid mb-4" alt=""/>
                                    <h5>Free Forever</h5>
                                    <small className="text-muted">Access all the inventory, sales & purchase features
                                        for free.</small>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card p-4" role="button">
                                <div className="card-body text-center">
                                    <img src={whyUsIcon2} className="img-fluid mb-4" alt=""/>
                                    <h5>Real-time Reports</h5>
                                    <small className="text-muted">Gather and share business insights in
                                        realtime.</small>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card p-4" role="button">
                                <div className="card-body text-center">
                                    <img src={whyUsIcon3} className="img-fluid mb-4" alt=""/>
                                    <h5>Privacy and Security</h5>
                                    <small className="text-muted">Your data is secure with a world class encryption
                                        standard.</small>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card p-4" role="button">
                                <div className="card-body text-center">
                                    <img src={whyUsIcon4} className="img-fluid mb-4" alt=""/>
                                    <h5>Easy to Use</h5>
                                    <small className="text-muted">Create any document with a few clicks.</small>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card p-4" role="button">
                                <div className="card-body text-center">
                                    <img src={whyUsIcon5} className="img-fluid mb-4" alt=""/>
                                    <h5>24/7 Chat Support</h5>
                                    <small className="text-muted">Our Average response time is less than a
                                        minute.</small>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card p-4" role="button">
                                <div className="card-body text-center">
                                    <img src={whyUsIcon6} className="img-fluid mb-4" alt=""/>
                                    <h5>Instant Access</h5>
                                    <small className="text-muted">Use TranZact anytime and anywhere in the
                                        world.</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="mb-5" id="testimonials">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-12">
                            <p className="notify text-primary text-center mb-2">TESTIMONIALS</p>
                            <h1>Check what our clients are saying</h1>
                        </div>
                        <div className="col-sm-5 p-5">
                            <img src={testimonial} className="img-fluid" alt=""/>
                        </div>
                        <div className="offset-sm-1 col-sm-6">
                            <img src={doubleQuotes} className="img-fluid d-block pb-3" alt=""/>
                            <div className="pb-4">
                                <img src={star} className="img-fluid" alt=""/>
                                <img src={star} className="img-fluid" alt=""/>
                                <img src={star} className="img-fluid" alt=""/>
                                <img src={star} className="img-fluid" alt=""/>
                                <img src={star} className="img-fluid" alt=""/>
                            </div>
                            <p className="pb-5">Is be upon sang fond must shew. Really boy law county she unable her
                                sister. Feet you off its like like six. Among sex are leave law built now.</p>
                            <h5>David Palak</h5>
                            <h6>CEO GetNextDesign</h6>
                        </div>
                    </div>
                </div>
            </section>

            <section className="mb-7" id="faq">
                <div className="container">
                    <div className="row">
                        <div className="col-12 mb-4 text-center">
                            <h1>Frequently Asked Questions</h1>
                        </div>
                        <div className="col-12 px-sm-5">
                            <div className="accordion" id="accordionContainer">
                                <div className="accordion-item px-4">
                                    <h2 className="accordion-header" id="headingOne">
                                        <button className="accordion-button" type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseOne" aria-expanded="true"
                                                aria-controls="collapseOne">
                                            What is Account App?
                                        </button>
                                    </h2>
                                    <div id="collapseOne" className="accordion-collapse collapse show"
                                         aria-labelledby="headingOne" data-bs-parent="#accordionContainer">
                                        <div className="accordion-body px-4 pt-0">
                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                                                veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
                                                commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
                                                velit esse cillum dolore eu fugiat nulla pariatur. </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item px-4">
                                    <h2 className="accordion-header" id="headingTwo">
                                        <button className="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseTwo"
                                                aria-expanded="false" aria-controls="collapseTwo">
                                            What is Account App?
                                        </button>
                                    </h2>
                                    <div id="collapseTwo" className="accordion-collapse collapse"
                                         aria-labelledby="headingTwo" data-bs-parent="#accordionContainer">
                                        <div className="accordion-body px-4 pt-0">
                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                                                veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
                                                commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
                                                velit esse cillum dolore eu fugiat nulla pariatur. </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item px-4">
                                    <h2 className="accordion-header" id="headingThree">
                                        <button className="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseThree"
                                                aria-expanded="false" aria-controls="collapseThree">
                                            What is Account App?
                                        </button>
                                    </h2>
                                    <div id="collapseThree" className="accordion-collapse collapse"
                                         aria-labelledby="headingThree" data-bs-parent="#accordionContainer">
                                        <div className="accordion-body px-4 pt-0">
                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                                                veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
                                                commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
                                                velit esse cillum dolore eu fugiat nulla pariatur. </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item px-4">
                                    <h2 className="accordion-header" id="headingFour">
                                        <button className="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseFour"
                                                aria-expanded="false" aria-controls="collapseFour">
                                            What is Account App?
                                        </button>
                                    </h2>
                                    <div id="collapseFour" className="accordion-collapse collapse"
                                         aria-labelledby="headingFour" data-bs-parent="#accordionContainer">
                                        <div className="accordion-body px-4 pt-0">
                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                                                veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
                                                commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
                                                velit esse cillum dolore eu fugiat nulla pariatur. </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item px-4">
                                    <h2 className="accordion-header" id="headingFive">
                                        <button className="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseFive"
                                                aria-expanded="false" aria-controls="collapseFive">
                                            What is Account App?
                                        </button>
                                    </h2>
                                    <div id="collapseFive" className="accordion-collapse collapse"
                                         aria-labelledby="headingFive" data-bs-parent="#accordionContainer">
                                        <div className="accordion-body px-4 pt-0">
                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                                                veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
                                                commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
                                                velit esse cillum dolore eu fugiat nulla pariatur. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer/>
        </>
    );
}

export default Home;